import { Tab } from './Tab';

export { Tab };
export default Tab;
